// extracted by mini-css-extract-plugin
var _1 = "CalendarItemCardTags-moduleCalendarItemCardTags__MrtVm";
export { _1 as "CalendarItemCardTags" }
